"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridRowClassNames: function() {
        return dataGridRowClassNames;
    },
    useDataGridRowStyles_unstable: function() {
        return useDataGridRowStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableRowStylesstyles = require("../TableRow/useTableRowStyles.styles");
const dataGridRowClassNames = {
    root: 'fui-DataGridRow',
    selectionCell: 'fui-DataGridRow__selectionCell'
};
const useDataGridRowStyles_unstable = (state)=>{
    (0, _useTableRowStylesstyles.useTableRowStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridRowClassNames.root, state.root.className);
    if (state.selectionCell) {
        state.selectionCell.className = (0, _react.mergeClasses)(dataGridRowClassNames.selectionCell, state.selectionCell.className);
    }
    return state;
}; //# sourceMappingURL=useDataGridRowStyles.styles.js.map
